import React, { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import './BrandedLoadingScreen.css';

const loadingMessages = [
  "Setting up your dashboard",
  "Bringing your courses together",
  "Laying out your assignments",
  "Building your study system",
  "Almost ready"
];

export default function BrandedLoadingScreen({ completedSteps = [] }) {
  const [messageIndex, setMessageIndex] = useState(0);

  // Cycle messages every 1.8s
  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex(prev => (prev + 1) % loadingMessages.length);
    }, 1800);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="branded-loading-screen">
      <div className="branded-loading-card">
        {/* Scout image with gentle scale pulse */}
        <motion.img
          src="/scout_images/scout_thumbs_up.png"
          alt="Scout"
          className="branded-loading-scout"
          animate={{ scale: [1, 1.03, 1], y: [0, -4, 0] }}
          transition={{ duration: 2.8, repeat: Infinity, ease: 'easeInOut' }}
        />

        {/* Headline */}
        <h2 className="branded-loading-headline">
          Scout is locking in your dashboard
        </h2>

        {/* Progress bar — animated purely via CSS keyframes */}
        <div className="branded-loading-progress-track">
          <div className="branded-loading-progress-fill">
            <div className="branded-loading-progress-shimmer" />
          </div>
        </div>

        {/* Rotating subtext */}
        <div className="branded-loading-message-container">
          <AnimatePresence mode="wait">
            <motion.p
              key={messageIndex}
              className="branded-loading-message"
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -8 }}
              transition={{ duration: 0.35 }}
            >
              {loadingMessages[messageIndex]}
            </motion.p>
          </AnimatePresence>
        </div>

        {/* Completed steps (optional) */}
        {completedSteps.length > 0 && (
          <div className="branded-loading-steps">
            {completedSteps.map((step, i) => (
              <motion.div
                key={i}
                className="branded-loading-step"
                initial={{ opacity: 0, x: -8 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: i * 0.15 }}
              >
                <span className="branded-loading-check">✓</span> {step}
              </motion.div>
            ))}
          </div>
        )}

        {/* Brand line */}
        <p className="branded-loading-subtext">
          Built for how students actually live.
        </p>
      </div>
    </div>
  );
}
